import React from 'react';
import styled from 'styled-components';
import imgClose from '../../images/common/i_close_btn.svg'
import careplusLogo from '../../images/common/logo_landing_new.svg'
import phons from '../../images/common/phons.svg'
import googleLogo from '../../images/common/google-logo.svg'
import playDownbtn from '../../images/common/play-downbtn.svg'


const ContentWrap = styled.div`
    position: fixed;
    top:0%;
    left:0%;
    width: 100%;
    height:100%;
    background-color: rgba(0,0,0,0.3);
    Z-index:1000;
`;

const InnerBox = styled.div`
    overflow: auto;
    display: flex; 
    flex-direction: column; 
    justify-content: flex-start; 
    position: absolute; 
    top:50%;
    left:50%;
    width: 80%;
    max-height: 95%;
    border-radius: var(--radius-16);
    background-color: #fff;
    transform: translate(-50%, -50%);
    padding: var(--sp-42) var(--sp-16) var(--sp-16); 

    & .close-btn {
        position: absolute; 
        top: var(--sp-16); 
        right: var(--sp-16);
        width: var(--sp-24); 
        height: var(--sp-24);
        background: url(${imgClose}) no-repeat center;
        background-size: 100%;
    }
`;


const ContentBox = styled.div`
    display: block;
    width: 100%;
`;

const ConTop = styled.div`
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center;

    & .logo {
        width: 100%;
        height: 2.4rem;
        background: url(${careplusLogo}) no-repeat center;
        background-size: auto 100%;   
    } 
    & strong {
        font-size: var(--mo-fz-xlg);
        margin-top: var(--sp-12);
        text-align: center;
    }    
    & .main-img {
        display: flex; 
        flex-direction: column; 
        justify-content: center; 
        align-items: center;
        width: 100%;
        height: 100%;
        margin-top: var(--sp-10);
    }  
`;

const ConMid = styled.div`
    & .google-logo {
        width: 100%;
        height: 2.4rem;
        margin-top: var(--sp-10);
        background: url(${googleLogo}) no-repeat center;
        background-size: auto 100%;   
    }
    & p {
        margin-top: var(--sp-12);
        font-size: var(--mo-fz-smd);
        color: var(--color-main-gray);
        text-align: center;
    }
    & .hit {
        margin-top: 0;
        font-weight: var(--fz-weight-700);
        color: var(--color-main-5);
        text-align: center;
    }    
`;

const ConBot = styled.div`
    & .google-play-btn {
        width: 100%;
        height: 5.33rem;
        margin-top: var(--sp-22);
        background: url(${playDownbtn}) no-repeat center;
        background-size: auto 100%;   
    }
`;







const AppNoticeBox = ({ onClose }) => {


    const handleOnDownload = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }

    return (

        <ContentWrap>

            <InnerBox>
                <ContentBox>
                    <ConTop>
                        <div className='logo'></div>
                        <strong>Google 스토어 정식 출시 안내</strong>
                        <div className='main-img'>
                            <object data={phons} type=""></object>
                        </div>
                    </ConTop>
                    <ConMid>
                        <div className='google-logo'></div>
                        <p>케어플러스 앱이 Google Play 스토어에 <br />
                            정식 출시되었습니다.
                        </p>
                        <p>기존에 APK 파일로 설치하여 이용중인 안드로이드 사용자분들께서는 안정적인 서비스 이용을 위해</p>
                        <p className='hit'>현재 앱을 삭제하신 후, Google Play 스토어를 통해 앱을 다시 설치해 주시기 바랍니다.</p>
                    </ConMid>
                    <ConBot>
                        <button className='google-play-btn'
                            onClick={() => handleOnDownload('https://play.google.com/store/apps/details?id=com.cmcnu.careplus')}
                        >
                            <span className='blind'>구글 플레이 다운로드로 이동</span>
                        </button>
                    </ConBot>
                </ContentBox>

                <button className='close-btn' onClick={onClose}>
                    <span className='blind'>팝업 닫기</span>
                </button>
            </InnerBox>
        </ContentWrap>

    )
}

export default AppNoticeBox;
